import { Controller } from "@hotwired/stimulus"

// LRPO-5574 — poll and live-refresh the admin exhibitor DataTable while an
// async import is in progress, then stop once the import finishes.
//
// Replaces the broken Turbo Stream / ActionCable nudge (LRPO-5574 part A).
// Unlike a constant poll this runs ONLY while `active` is true, so an idle
// page generates zero background traffic.
export default class extends Controller {
  static values = {
    table: String,
    statusUrl: String,
    active: Boolean,
    interval: { type: Number, default: 4000 },
    counter: String
  }

  connect() {
    if (!this.activeValue) return

    this._timer = setInterval(this.tick, this.intervalValue)
  }

  tick = async () => {
    this.reloadTable()

    try {
      const res = await fetch(this.statusUrlValue, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      if (!res.ok) return
      const data = await res.json()
      this.updateCounter(data)
      if (data.active_import === false) {
        this.reloadTable()
        clearInterval(this._timer)
      }
    } catch {
      // Fetch failed — keep polling; transient network blip.
    }
  }

  reloadTable() {
    const jq = window.jQuery || window.$
    const selector = this.tableValue
    if (!jq || !selector) return

    const dt = jq.fn && jq.fn.DataTable
    if (!dt || !dt.isDataTable(selector)) return

    // `false` keeps the current paging position so a background reload doesn't
    // yank an admin who has paged/searched back to page 1.
    jq(selector).DataTable().ajax.reload(null, false)
  }

  updateCounter(data) {
    if (!this.hasCounterValue || data.active_exhibitors_count == null) return
    const el = document.querySelector(this.counterValue)
    if (el) el.textContent = data.active_exhibitors_count
  }

  disconnect() {
    clearInterval(this._timer)
  }
}
